import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingSpinner = ({ 
  size = 'default', 
  tip = 'Loading...', 
  className = '',
  spinning = true,
  children 
}) => {
  const antIcon = <LoadingOutlined style={{ fontSize: size === 'large' ? 24 : 16 }} spin />;

  if (children) {
    return (
      <Spin 
        spinning={spinning} 
        indicator={antIcon}
        tip={tip}
        className={className}
      >
        <div className="min-h-[200px]">
          {children}
        </div>
      </Spin>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <Spin 
        size={size} 
        indicator={antIcon}
      />
      {tip && <div className="mt-3 text-gray-500 text-sm">{tip}</div>}
    </div>
  );
};

export default LoadingSpinner;
